import ChartingBaseController from './charting_base_controller';

export default class extends ChartingBaseController {
  static values = { actions: { type: Array, default: [] } };

  execute() {
    this.applyActions(this.actionsValue, { value: true });
  }
}
